const Base64 = require('js-base64').Base64;
const strtr = require('locutus/php/strings/strtr')
const rtrim = require('locutus/php/strings/rtrim')
module.exports = {
    encode : function(str){    
        return rtrim(strtr(Base64.encode(str) , '+/', '-_'), '=');
    },
    decode : function(str){
        return Base64.decode(strtr(str, '-_', '+/'))
    }
}